import { Col, Row, Spin } from "antd";
import { PostGrid } from "@components/grid";
import { useGetPostsQuery } from "@mwServices/Post";


interface RelatedPostsProps {
  className?: string;
  attrs?: any;
}

const defaultProps: RelatedPostsProps = {};

const RelatedPosts = ({ className, attrs }: RelatedPostsProps) => {
  const {
    data,
    isLoading,
  } = useGetPostsQuery({
    terms: attrs?.tags?.map((m) => m.term_id) ?? [],
    taxonomies: attrs?.taxonomies,
    random: true,
    page: 1,
    perPage: 2,
  }) ?? [];

  return (
    <Spin size="large" spinning={isLoading}>
      <Row className={`related-posts mar-y-30`}>
        <Col>
          <h3>Article You May Also Like</h3>
          {data?.results
            && (
              <PostGrid
                className={className}
                data={data.results}
                showFields={['title', 'description']}
                cta={{
                  type: 'Flag',
                  layout: [12, 12]
                }}
                perRow={2}
              />
            )}
        </Col>
      </Row>
    </Spin>
  );
};

RelatedPosts.defaultProps = defaultProps;

export default RelatedPosts;
